module.exports = require("core-js/library/fn/object/define-property");


// WEBPACK FOOTER //
// ../node_modules/@babel/runtime-corejs2/core-js/object/define-property.js